import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_team_management-set_role_and_permissions-click';

/**
 * Click event for set roles and permissions button on lean invite toast
 */
export function trackRetailerTeamManagementSetRoleAndPermissionsClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
